// Formatting shared by every billing message, so the Plans page, the pop-ups,
// the banners and the checkout confirmations say numbers and dates the same way.

export const formatMoney = (amount, currency) => {
  const symbol = currency === "INR" ? "₹" : "$";
  const locale = currency === "INR" ? "en-IN" : "en-US";
  return `${symbol}${Number(amount || 0).toLocaleString(locale)}`;
};

export const formatCount = (n) => Number(n || 0).toLocaleString("en-IN");

// "2027-01-27" or an ISO datetime -> "27 Jan 2027". Parsed as a calendar date,
// not a moment in time, so it never shifts a day across time zones.
export const formatDate = (value, { year = true } = {}) => {
  if (!value) return "";
  const [y, m, d] = String(value).slice(0, 10).split("-").map(Number);
  if (!y || !m || !d) return String(value);
  const date = new Date(Date.UTC(y, m - 1, d));
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    ...(year ? { year: "numeric" } : {}),
    timeZone: "UTC",
  });
};

// Which credit a feature key spends, for the limit pop-up.
export const creditForFeature = (featureKey) =>
  ["resume_screening_count", "bulk_upload"].includes(featureKey) ? "cvs" : "interviews";

export const CREDIT_WORDS = {
  interviews: { plural: "interviews", one: "interview" },
  cvs: { plural: "CV screenings", one: "CV screening" },
};

// The one place "your unused X and Y come with you" is worded.
export const carryLine = (carry) => {
  const parts = [];
  if (carry?.interviews) parts.push(`${formatCount(carry.interviews)} unused interviews`);
  if (carry?.cvs) parts.push(`${formatCount(carry.cvs)} unused CV screenings`);
  if (!parts.length) return "";
  return `Your ${parts.join(" and ")} come with you.`;
};
